import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import deviceAxios from '../../../../utils/axios/device.axios';

const tryToFetchPrompts = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/ai-search-engine/config-prompts?page=${pageNumber}&size=${pageSize}&status=${filters}`
        : `${DEVICE_INFO_API_URL}/ai-search-engine/config-prompts?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<any>(url, data);
};

const tryToFetchPromptsSources = (
    pageNumber: number,
    pageSize: number,
    id: string,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/leo/all/sources/urls?page=${pageNumber}&size=${pageSize}&status=${filters}&promptId=${id}`
        : `${DEVICE_INFO_API_URL}/leo/all/sources/urls?page=${pageNumber}&size=${pageSize}&promptId=${id}`;
    return deviceAxios.get<any>(url, data);
};

const tryToFetchSinglePrompt = (id: string): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/ai-search-engine/config-prompts/${id}`);
};

const tryToFetchPromptIndustryRanking = (id: string, model?: string, pageNumber?: number, pageSize?: number): Promise<AxiosResponse<any>> => {
    let url = `${DEVICE_INFO_API_URL}/leo/industry-rankings-by-prompt/${model || 'all'}/${id}` 
    if(pageNumber || pageSize){
        url = url + `?page=${pageNumber}&size=${pageSize}`
    }
    return deviceAxios.get(url);
};

const tryToFetchPromptVoice = (id: string): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/leo/share-of-voice?promptId=${id}`);
};

const tryToFetchPromptModelDetails = (id: string, model: string): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/leo/prompt-details/${id}/${model}`);
};

const tryToGenerateNewPrompts = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/generate-config-prompts`);
};

const tryToAcceptSuggestedPrompt = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/suggested`, data);
};

const tryToEditPrompt = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/update-config-prompt`, data);
};

const tryToDeletePrompt = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.delete(`${DEVICE_INFO_API_URL}/ai-search-engine/delete-config-prompt/${data?.id}`);
};

const tryToAddPrompts = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.post(`${DEVICE_INFO_API_URL}/ai-search-engine/add-prompts`, data);
};

export const PromptsService = {
    tryToFetchPrompts,
    tryToFetchSinglePrompt,
    tryToFetchPromptIndustryRanking,
    tryToFetchPromptVoice,
    tryToFetchPromptsSources,
    tryToFetchPromptModelDetails,
    tryToAddPrompts,
    tryToGenerateNewPrompts,
    tryToAcceptSuggestedPrompt,
    tryToEditPrompt,
    tryToDeletePrompt
};